module.exports = __webpack_public_path__ + "static/media/ideal.afbc9773.svg";